import React from 'react'
import { ListItem, ComboTooltip } from '@fs/zion-ui'
import { ContentLock, ContentEdit } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { getMostRecentFieldValue } from '@fs/zion-sls'
import { useR2DispatchContext } from '../../../../providers/r2Provider/R2Context'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useCollectionContextProvider } from '../../../../providers/collectionProvider/CollectionProvider'
import { FIELDS } from '../../../../providers/collectionProvider/collectionConstants'

export default function EditSharedFieldButton({ field, readonly = true }) {
  const [t] = useTranslation()
  const dispatch = useR2DispatchContext()
  const { openOverlay } = useOverlayContext()

  const { restrictedFields } = useCollectionContextProvider()
  const isRestricted = restrictedFields?.includes(FIELDS.NAME)

  const sharedFieldTooltipLabel = t('edit.shared-field.tooltip-label', 'Linked Field')
  const sharedFieldTooltipDescription = t(
    'edit.shared-field.tooltip-description',
    'This field is temporarily disabled since the information connects many names together.'
  )
  const fieldDisplayLabel = field?.label?.toLowerCase()

  const getDisplayField = (parent, subElement) => {
    if (parent && !subElement) return parent
    return subElement
  }

  return (
    <>
      {readonly ? (
        <ListItem
          data-testid={field?.fieldType || field?.elementType}
          overline={field.label}
          primaryText={getMostRecentFieldValue(field) || ''}
          secondaryText={t('edit.shared-field.readonly-caption', 'This information is connected to many names.')}
          endElement={
            <ComboTooltip
              label={sharedFieldTooltipLabel}
              description={sharedFieldTooltipDescription}
              onClick={() => {}}
              target={<ContentLock />}
            />
          }
          onClick={() => {}}
        />
      ) : (
        <ListItem
          data-testid={field?.fieldType || field?.elementType}
          overline={field.label}
          primaryText={getMostRecentFieldValue(getDisplayField(field, field?.subElements?.[0])) || ''}
          secondaryText={t(
            'edit.shared-field.caption',
            'This information is connected to many names. Edit linked {fieldName}.',
            { fieldName: fieldDisplayLabel }
          )}
          disabled={isRestricted}
          endElement={<ListItem.Icon Icon={ContentEdit} />}
          onClick={() => {
            dispatch({ type: 'SET_ACTIVE_FIELD_ID', value: field?.id })
            dispatch({ type: 'SET_EDITING_SHARED_FIELD_ID', value: field?.id })
            openOverlay('editSharedFieldPage1')
          }}
        />
      )}
    </>
  )
}
